import PropTypes, { oneOfType } from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Menu, { setActiveItems } from './Menu';
import MenuItem from './MenuItem';
import { regExBillingAccountPathHelper } from '../utils/pathHelpers';
import ArrowIcon from '../../../img/sprite/arrow-right.svg';
import {
  PATH_LOGGED_OUT, PATH_PERSONAL_ACCOUNT, PATH_PROFILE, PATH_SHIPPING_ADDRESSES,
  PATH_ORDER_HISTORY, PATH_GIFT_CARDS, PATH_DIGITAL_MEDIA, PATH_REDEEM_CODE,
  PATH_ORG_MGMT, PATH_PAYMENT_METHODS, PATH_CREDIT_CARDS, PATH_SUBSCRIPTIONS, PATH_MANAGE_ACCESS, ENABLE_ORG_MANAGEMENT
} from '../constants';

const SharedIconStyles = css`
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  li  li & {
    display: none;
  }
`;

const ActiveIcon = styled.svg`
  ${SharedIconStyles}
  margin-left: 0.692em;
  margin-top: -0.308em;
  transform: rotate(90deg);
`;

const InactiveIcon = styled.svg`
  ${SharedIconStyles}
  margin-left: 0.462em;
  margin-top: -0.231em;
`;

export default class PersonNavMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAccountSubItems: false,
      showPaymentSubItems: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    // only render once every location change
    if (nextProps.location !== this.props.location || JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }
    return nextProps.noRender !== this.props.noRender;
  }

  updateShowAccountSubItems = () => {
    const { showAccountSubItems } = this.state;
    this.setState({
      showAccountSubItems: !showAccountSubItems
    });
  }

  updateShowPaymentSubItems = () => {
    const { showPaymentSubItems } = this.state;
    this.setState({
      showPaymentSubItems: !showPaymentSubItems
    });
  }

  render() {
    const { location, isOpen, navToggle, isMobile } = this.props;
    const { showAccountSubItems, showPaymentSubItems } = this.state;

    const styles = this.props.styles || {};
    const icons = this.props.icons || {
      activeIcon: <ActiveIcon><use xlinkHref={`#${ArrowIcon.id}`} /></ActiveIcon>,
      inactiveIcon: <InactiveIcon><use xlinkHref={`#${ArrowIcon.id}`} /></InactiveIcon>
    };
    const NavItem = (props) => <MenuItem location={location} icons={icons} styles={styles} navToggle={navToggle} isOpen={isOpen} {...props} />;
    const NavList = (props) => <Menu styles={styles} {...props} />;

    // shows org sub links only if org selected //
    const isOnOrg = location.pathname.match('(billing-account.*?(order-history.*?|account-activity))');

    const menu = (
      isMobile ?
      // MOBILE NAV //
        <NavList isActive>
          <NavItem firstChild title="My Account" btnClick={this.updateShowAccountSubItems} showChildren={showAccountSubItems} data-qa-hook="personalAccount.link">
            <NavList showChildren={showAccountSubItems}>
              <NavItem title="Profile" href={PATH_PROFILE} data-qa-hook="profile.link" />
              <NavItem title="Shipping Addresses" href={PATH_SHIPPING_ADDRESSES} data-qa-hook="shippingAddresses.link" />
              <NavItem title="Subscriptions" href={PATH_SUBSCRIPTIONS} data-qa-hook="subscriptions.link" />
            </NavList>
          </NavItem>
          <NavItem title="Orders" href={PATH_ORDER_HISTORY} data-qa-hook="orderHistory.link" />
          <NavItem title="Digital Media" href={PATH_DIGITAL_MEDIA} data-qa-hook="mediaContent.link" />
          <NavItem title="Manage Access" href={PATH_MANAGE_ACCESS} data-qa-hook="manageAccss.link" />
          {!ENABLE_ORG_MANAGEMENT && (
            isOnOrg ?
              <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link">
                <NavList>
                  <NavItem title="All Accounts" href={`${PATH_ORG_MGMT}/billing-accounts`} data-qa-hook="orgManagement.link" />
                  <NavItem title="Order History" href={regExBillingAccountPathHelper(location.pathname, 'order-history')} data-qa-hook="orgManagementOrderHistory.link" />
                  <NavItem title="Account Activity" href={regExBillingAccountPathHelper(location.pathname, 'account-activity')} data-qa-hook="orgManagementAcctShow.link" />
                </NavList>
              </NavItem>
              :
              <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link" />
          )}
          <NavItem title="Payment Methods" btnClick={this.updateShowPaymentSubItems} showChildren={showPaymentSubItems} data-qa-hook="paymentMethods.link">
            <NavList showChildren={showPaymentSubItems}>
              <NavItem title="Credit Cards" href={PATH_CREDIT_CARDS} data-qa-hook="creditCards.link" />
              <NavItem title="Gift Cards" href={PATH_GIFT_CARDS} data-qa-hook="paymentMethodsGiftCards.link" />
            </NavList>
          </NavItem>
          <NavItem title="Redeem Code" href={PATH_REDEEM_CODE} data-qa-hook="redeemCode.link" />
        </NavList>
      :
      // DESKTOP NAV //
      <NavList isActive>
        <NavItem firstChild title="My Account" href={PATH_PERSONAL_ACCOUNT} data-qa-hook="personalAccount.link">
          <NavList>
            <NavItem title="Profile" href={PATH_PROFILE} data-qa-hook="profile.link" />
            <NavItem title="Shipping Addresses" href={PATH_SHIPPING_ADDRESSES} data-qa-hook="shippingAddresses.link" />
            <NavItem title="Subscriptions" href={PATH_SUBSCRIPTIONS} data-qa-hook="subscriptions.link" />
          </NavList>
        </NavItem>
        <NavItem title="Orders" href={PATH_ORDER_HISTORY} data-qa-hook="orderHistory.link" />
        <NavItem title="Digital Media" href={PATH_DIGITAL_MEDIA} data-qa-hook="mediaContent.link" />
        <NavItem title="Manage Access" href={PATH_MANAGE_ACCESS} data-qa-hook="manageAccss.link" />
        {!ENABLE_ORG_MANAGEMENT && (
          isOnOrg ?
            <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link">
              <NavList>
                <NavItem title="All Accounts" href={`${PATH_ORG_MGMT}/billing-accounts`} data-qa-hook="orgManagement.link" />
                <NavItem title="Order History" href={regExBillingAccountPathHelper(location.pathname, 'order-history')} data-qa-hook="orgManagementOrderHistory.link" />
                <NavItem title="Account Activity" href={regExBillingAccountPathHelper(location.pathname, 'account-activity')} data-qa-hook="orgManagementAcctShow.link" />
              </NavList>
            </NavItem>
            :
            <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link" />
        )}
        <NavItem title="Payment Methods" href={PATH_PAYMENT_METHODS} data-qa-hook="paymentMethods.link">
          <NavList>
            <NavItem title="Credit Cards" href={PATH_CREDIT_CARDS} data-qa-hook="creditCards.link" />
            <NavItem title="Gift Cards" href={PATH_GIFT_CARDS} data-qa-hook="paymentMethodsGiftCards.link" />
          </NavList>
        </NavItem>
        <NavItem lastChild title="Redeem Code" href={PATH_REDEEM_CODE} data-qa-hook="redeemCode.link" />
      </NavList>
    );

    const _crumbs = [];
    const navMenu = setActiveItems(menu, this.props, 0, false, _crumbs);
    return navMenu;
  }
}

const { object, func, bool, shape, node, string, array } = PropTypes;

PersonNavMenu.propTypes = {
  location: object.isRequired,
  navToggle: func,
  isOpen: bool,
  isMobile: bool,

  // are used on mobile to create the breadcrumb menu (in setActiveItems)
  isBreadCrumb: bool,
  renderBreadCrumb: func,

  icons: shape({
    iconActive: node,
    iconInactive: node
  }),
  // Will warn sometimes until all are changed to Styled-Components: string VS array //
  styles: shape({
    ulCommon: oneOfType([array, string]),
    ulActive: oneOfType([array, string]),
    ulInactive: oneOfType([array, string]),
    liCommon: oneOfType([array, string]),
    liActive: oneOfType([array, string]),
    liInactive: oneOfType([array, string]),
    aCommon: oneOfType([array, string]),
    aActive: oneOfType([array, string]),
    aInactive: oneOfType([array, string]),
    firstChildStyles: object,
    lastChildStyles: object,
  })
};
